<div class="w-full hidden md:block" id="chain-hotels">
    <ng-container  *ngIf="resetSwiper()">
        <swiper [config]="configSwiper">
            <ng-template swiperSlide *ngFor="let itemHotel of chainHotels">
                <ng-container *ngIf="itemHotel?.PictureUrl">
                    <a [href]="itemHotel.Url" class="rounded-lg object-contain h-[124px] w-[124px] flex justify-center items-center bg-white grayscale hover:grayscale-0 transition-all">
                        <img 
                        id="hotel-chain"
                        [ngSrc]="itemHotel.PictureUrl" 
                        (error)="itemHotel.PictureUrl = cdnUrl + '/images/no-image.jpg'"
                        [alt]="itemHotel.PictureName" 
                        [loading]="'eager'"
                        height="90"
                        width="90" class="h-24 w-24">
                    </a>
                </ng-container>
            </ng-template>
        </swiper>
    </ng-container>
</div>



<div class="w-full my-5 md:hidden" id="chain-hotels">
    <ng-container *ngIf="resetSwiper()">    
    <swiper [config]=" configSwiperRev">
        <ng-template swiperSlide *ngFor="let item of chainHotels">
            <ng-container *ngIf="item?.PictureUrl">
                <a [href]="item.Url" class="rounded-lg object-contain h-[124px] w-[124px] flex justify-center items-center bg-white grayscale hover:grayscale-0 transition-all">
                    <img 
                    id="hotel-chain"
                    [ngSrc]="item.PictureUrl" 
                    (error)="item.PictureUrl = cdnUrl + '/images/no-image.jpg'"
                    [alt]="item.PictureName"
                    height="90"
                    [loading]="'eager'"
                    width="90" class="h-24 w-24">
                </a>
            </ng-container>
        </ng-template>
    </swiper>
    </ng-container>
</div>